import icon0 from './001-narrow.png';
import icon1 from './002-merge.png';
import icon2 from './003-curve.png';
import icon3 from './004-curve.png';
import icon4 from './005-Junction.png';
import icon5 from './006-curve.png';
import icon6 from './007-crossroads.png';
import icon7 from './008-hump.png';
import icon8 from './009-uneven.png';
import icon9 from './010-roundabout.png';
import icon10 from './011-Two way.png';
import icon11 from './012-Junction.png';
import icon12 from './013-Junction.png';
import icon13 from './014-Two way.png';
import icon14 from './015-level.png';
import icon15 from './016-warning.png';
import icon16 from './017-hump.png';
import icon17 from './018-dock.png';
import icon18 from './019-merge.png';
import icon19 from './020-falling rocks.png';
import icon20 from './021-speed limit.png';
import icon21 from './022-speed limit.png';
import icon22 from './023-speed limit.png';
import icon23 from './024-speed limit.png';
import icon24 from './025-speed limit.png';
import icon25 from './026-speed limit.png';
import icon26 from './027-speed limit.png';
import icon27 from './028-priority.png';
import icon28 from './029-no overtaking.png';
import icon29 from './030-no turn right.png';
import icon30 from './031-u turn.png';
import icon31 from './032-no stopping.png';
import icon32 from './033-no waiting.png';
import icon33 from './034-ahead.png';
import icon34 from './035-turn left.png';
import icon35 from './036-keep left.png';
import icon36 from './037-direction.png';
import icon37 from './038-turn left.png';
import icon38 from './039-roundabout.png';
import icon39 from './040-no entry.png';
import icon40 from './041-parking.png';
import icon41 from './042-priority.png';
import icon42 from './043-cul de sac.png';
import icon43 from './044-countdown.png';
import icon44 from './045-countdown.png';
import icon45 from './046-countdown.png';
import icon46 from './047-hospital.png';
import icon47 from './048-information.png';
import icon48 from './049-speed camera.png';
import icon49 from './050-lane.png';
import icon50 from './051-end motorway.png';
import icon51 from './052-motorway.png';
import icon52 from './053-one way.png';
import icon53 from './054-direction.png';
import icon54 from './055-stop.png';
import icon55 from './056-road.png';
import icon56 from './057-emergency diversion.png';
import icon57 from './058-emergency diversion.png';
import icon58 from './059-emergency diversion.png';
import icon59 from './060-emergency diversion.png';

const textures = {
  '001-narrow': icon0,
  '002-merge': icon1,
  '003-curve': icon2,
  '004-curve': icon3,
  '005-Junction': icon4,
  '006-curve': icon5,
  '007-crossroads': icon6,
  '008-hump': icon7,
  '009-uneven': icon8,
  '010-roundabout': icon9,
  '011-Two way': icon10,
  '012-Junction': icon11,
  '013-Junction': icon12,
  '014-Two way': icon13,
  '015-level': icon14,
  '016-warning': icon15,
  '017-hump': icon16,
  '018-dock': icon17,
  '019-merge': icon18,
  '020-falling rocks': icon19,
  '021-speed limit': icon20,
  '022-speed limit': icon21,
  '023-speed limit': icon22,
  '024-speed limit': icon23,
  '025-speed limit': icon24,
  '026-speed limit': icon25,
  '027-speed limit': icon26,
  '028-priority': icon27,
  '029-no overtaking': icon28,
  '030-no turn right': icon29,
  '031-u turn': icon30,
  '032-no stopping': icon31,
  '033-no waiting': icon32,
  '034-ahead': icon33,
  '035-turn left': icon34,
  '036-keep left': icon35,
  '037-direction': icon36,
  '038-turn left': icon37,
  '039-roundabout': icon38,
  '040-no entry': icon39,
  '041-parking': icon40,
  '042-priority': icon41,
  '043-cul de sac': icon42,
  '044-countdown': icon43,
  '045-countdown': icon44,
  '046-countdown': icon45,
  '047-hospital': icon46,
  '048-information': icon47,
  '049-speed camera': icon48,
  '050-lane': icon49,
  '051-end motorway': icon50,
  '052-motorway': icon51,
  '053-one way': icon52,
  '054-direction': icon53,
  '055-stop': icon54,
  '056-road': icon55,
  '057-emergency diversion': icon56,
  '058-emergency diversion': icon57,
  '059-emergency diversion': icon58,
  '060-emergency diversion': icon59,
};

export default textures;